import { Dialog, IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { SalesPartnerBankAccountsServices } from 'src/services/salesPartner/SalesPartnerBankAccountsServices';
import { useSalesPartnerData } from '../../SalesPartnerData';
import EditSalesPartnerBankAccount from './EditSalesPartnerBankAccount';

const options = ['Edit', 'Delete'];
const ITEM_HEIGHT = 48;

const SalesPartnerBankAccountOptions = ({ rowData }) => {
  const { setBankAccounts, setBankAccountsList, bankAccountsList } = useSalesPartnerData();
  const [openEdit, setOpenEdit] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleCloseDialog = () => setOpenEdit(false);

  const handleOptionClick = (option: string) => {
    if (option === 'Edit') {
      setBankAccounts(rowData);
      setOpenEdit(true);
      handleClose();
    } else if (option === 'Delete') {
      SalesPartnerBankAccountsServices.deleteData(rowData.id)
        .then(() => {
          enqueueSnackbar(`Bank account '${rowData.accountName}' deleted successfully`, { variant: 'success' });
          const updated = bankAccountsList.filter((f) => f.id !== rowData.id);
          setBankAccountsList(updated);
        })
        .catch(() => {
          enqueueSnackbar(`Bank account '${rowData.accountName}' not deleted`, { variant: 'error' });
        });
      handleClose();
    }
  };

  return (
    <>
      <IconButton onClick={handleClick}><MoreVertIcon /></IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {options.map((option) => (
          <MenuItem key={option} onClick={() => handleOptionClick(option)}>{option}</MenuItem>
        ))}
      </Menu>

      <Dialog open={openEdit} onClose={handleCloseDialog}>
        {openEdit && <EditSalesPartnerBankAccount handleClose={handleCloseDialog} />}
      </Dialog>
    </>
  );
};

export default SalesPartnerBankAccountOptions;